import { FC, useState } from "react";
import {
  PropertyGroupSplitBy,
  PropertyGroupStep
} from "views/property-groups-configuration/types";
import { SplitModal } from "./components/SplitModal";
import { Show } from "shared/components/helpers/Show";
import {
  getPreviousStepTitle,
  tranformToSankeyData
} from "views/property-groups-configuration/utils";
import {
  PropertyGroupChartLegendItems,
  propertyGroupTitleMap
} from "views/property-groups-configuration/constants";
import { Card } from "shared/components/Card";
import { useUnitsPropertiesDictionary } from "shared/hooks/use-units-properties";
import { PropertyGroupsSankeyChart } from "views/property-groups-configuration/components/PropertyGroupsSankeyChart";
import { Loader } from "shared/components/Loader";
import { Button, ButtonVariant } from "shared/components";
import { useSpotlightContext } from "views/property-groups-configuration/providers/SpotlightProvider";

export const SplitByOptionSlice: FC<{
  isLoadingSegments: boolean;
  currentStep: PropertyGroupSplitBy;
  selectedSplitOptions: PropertyGroupSplitBy[];
  segments: any;
  handleUpdateSegments: (data: { nodeId: string; splitDatas: any }) => void;
}> = ({
  isLoadingSegments,
  currentStep,
  selectedSplitOptions,
  segments,
  handleUpdateSegments
}) => {
  const dictionary = useUnitsPropertiesDictionary();
  const [openSplitModal, setOpenSplitModal] = useState(false);

  const { helpDriver } = useSpotlightContext();

  const sankeyData = tranformToSankeyData(
    segments,
    selectedSplitOptions,
    dictionary
  );

  return (
    <div className="space-y-6">
      <div className="space-y-3">
        <h1 className="text-2xl font-bold">
          {`Split ${getPreviousStepTitle(
            selectedSplitOptions,
            currentStep,
            dictionary.properties
          )} by ${propertyGroupTitleMap[currentStep]}`}
        </h1>
        <p className="text-sm text-content-400">
          Please split{" "}
          {getPreviousStepTitle(
            selectedSplitOptions,
            currentStep,
            dictionary.properties
          )}{" "}
          by {propertyGroupTitleMap[currentStep]} and press &quot;Continue&quot;
          when you are finished
        </p>
      </div>

      <Card>
        <div className="flex justify-between items-center py-4 px-6 border-b border-alpha-100 relative">
          <div className="flex items-center gap-2">
            <Button
              variant={ButtonVariant.TEXT}
              className="flex items-center gap-2"
              onClick={() => {
                helpDriver?.drive();
              }}
            >
              Get help
            </Button>
          </div>
          <div className="flex items-center gap-4">
            {PropertyGroupChartLegendItems.map((item, index) => (
              <div key={index} className="flex items-center gap-2">
                <span className={`size-2 rounded-full ${item.color}`} />
                <p className="text-xs text-content-400 font-medium">
                  {item.label === "Segments"
                    ? "Segments"
                    : `${dictionary.Property} groups`}
                </p>
              </div>
            ))}
          </div>
        </div>
        <div className="h-[700px] relative">
          {sankeyData.nodes.length > 0 ? (
            <PropertyGroupsSankeyChart
              key={selectedSplitOptions.join(",")}
              currentStep={currentStep as unknown as PropertyGroupStep}
              selectedSplitOptions={selectedSplitOptions}
              data={sankeyData}
              handleClick={() => setOpenSplitModal(true)}
            />
          ) : (
            <div className="flex justify-center items-center h-[100vh]">
              <Loader />
            </div>
          )}
        </div>
      </Card>

      <Show if={openSplitModal}>
        <SplitModal
          splitBy={selectedSplitOptions}
          opened={openSplitModal}
          onClose={() => setOpenSplitModal(false)}
          currentStep={currentStep}
          currentSegments={segments || []}
          selectedSplitOptions={selectedSplitOptions}
          updateSegments={handleUpdateSegments}
          isLoadingSegments={isLoadingSegments}
        />
      </Show>
    </div>
  );
};
